module.exports = "<div class=\"stepper-wrapper\">\r\n  <ng-container *ngFor=\"let item of steps;let index = index\">\r\n    <div class=\"stepper-item\" \r\n      [ngClass]=\"{'active': item.active && !item.completed, 'completed': item.completed}\"\r\n      (click)=\"onchange.emit(index)\" [matTooltip]=\"item.tooltip\" matTooltipPosition=\"above\">\r\n      <div class=\"step-counter\">{{item.text}}</div>  \r\n    </div>\r\n  </ng-container>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/stepper/stepper.component.html
// module id = ../../../../../src/app/components/stepper/stepper.component.html
// module chunks = main